import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { StarAuthShell } from "@/pages/star/StarLayout";

export default function StudentActivateVerify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("checking"); // checking | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    let done = false;
    (async () => {
      if (!token) { setState("error"); setMsg("Missing verification token."); return; }
      try {
        const { data } = await api.post("/auth/student/activate/verify", { token });
        if (done) return;
        setState("ok"); setMsg(data.message || "Email verified. Awaiting PTG admin approval.");
      } catch (err) {
        if (done) return;
        setState("error"); setMsg(err.response?.data?.detail || "This link is invalid or expired.");
      }
    })();
    return () => { done = true; };
  }, [token]);

  return (
    <StarAuthShell title="Email Verification" subtitle="PTG account activation">
      <Seo title="Verify Email" />
      <div className="mt-6 text-center space-y-3" data-testid="activate-verify">
        {state === "checking" && <><Loader2 className="h-10 w-10 animate-spin text-blue-900 mx-auto" /><p className="text-slate-600">Verifying…</p></>}
        {state === "ok" && <>
          <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto" data-testid="verify-ok" />
          <p className="text-slate-800 font-semibold">{msg}</p>
          <p className="text-sm text-slate-500">You'll be able to log in once PTG approves your account. We'll email you when it's approved.</p>
          <Link to="/student/login" className="inline-block font-semibold text-blue-900 hover:underline">Go to Login</Link>
        </>}
        {state === "error" && <>
          <XCircle className="h-12 w-12 text-red-600 mx-auto" data-testid="verify-error" />
          <p className="text-slate-800 font-semibold">{msg}</p>
          <Link to="/student/activate" className="inline-block font-semibold text-blue-900 hover:underline">Back to Activate Account</Link>
        </>}
      </div>
    </StarAuthShell>
  );
}
